var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70814 3.33398H7.99934C10.042 3.33398 11.0634 3.33398 11.4511 3.69884C11.7863 4.01423 11.9348 4.47884 11.8443 4.92879C11.7396 5.44933 10.9058 6.03589 9.23806 7.209L6.51339 9.12563C4.84569 10.2987 4.01184 10.8853 3.90716 11.4058C3.81668 11.8558 3.9652 12.3204 4.30034 12.6358C4.68805 13.0007 5.7094 13.0007 7.75212 13.0007H8.37849M5.36193 3.33398C5.36193 4.43855 4.46155 5.33398 3.35088 5.33398C2.24022 5.33398 1.33984 4.43855 1.33984 3.33398C1.33984 2.22941 2.24022 1.33398 3.35088 1.33398C4.46155 1.33398 5.36193 2.22941 5.36193 3.33398ZM14.7468 12.6673C14.7468 13.7719 13.8464 14.6673 12.7357 14.6673C11.6251 14.6673 10.7247 13.7719 10.7247 12.6673C10.7247 11.5627 11.6251 10.6673 12.7357 10.6673C13.8464 10.6673 14.7468 11.5627 14.7468 12.6673Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapping);
export default __webpack_public_path__ + "static/media/Mapping.966699ea17cab62637f3093641086814.svg";
export { ForwardRef as ReactComponent };